var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3175_16327)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3175_16327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.2867,
    cy: 28.713,
    r: 22.9703,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.6896 18.4542C33.1839 17.3685 31.2925 16.8257 29.0155 16.8257C27.2839 16.8257 25.8218 17.2074 24.6344 17.9721C22.7496 19.1688 21.7485 21.2015 21.627 24.0676H25.9948C25.9948 23.2315 26.2392 22.4298 26.7252 21.6532C27.2126 20.8792 28.0394 20.4922 29.2057 20.4922C30.3917 20.4922 31.2093 20.8066 31.6544 21.4339C32.1022 22.0639 32.3254 22.76 32.3254 23.5234C32.3254 24.1891 31.9925 24.798 31.5897 25.3501C31.3496 25.6928 31.0546 25.9936 30.7166 26.2403C30.7166 26.2403 28.3485 27.7592 27.309 28.9796C26.7067 29.6862 26.6526 30.7468 26.5984 32.2657C26.5958 32.374 26.6367 32.5986 27.0145 32.5986H30.4102C30.7483 32.5986 30.8183 32.349 30.8223 32.2367C30.8461 31.6846 30.9068 31.4006 31.0085 31.081C31.1987 30.4774 31.7191 29.9517 32.3016 29.4974L33.5035 28.6692C34.5892 27.8226 35.4543 27.1292 35.8374 26.585C36.4898 25.6922 36.9495 24.5906 36.9495 23.283C36.9481 21.15 36.1953 19.5426 34.6896 18.4542ZM28.9455 35.2164C27.4411 35.1702 26.1995 36.2123 26.152 37.8448C26.1058 39.4746 27.2852 40.5537 28.7909 40.5973C30.3614 40.6435 31.5699 39.6371 31.6187 38.0046C31.6637 36.3721 30.5172 35.2626 28.9455 35.2164Z",
    fill: "#FBB040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3175_16327",
    x: 1.72235,
    y: 4.0199,
    width: 55.1285,
    height: 55.1285,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.87129
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29703
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3175_16327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3175_16327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3175_16327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.d8f56714f35dfe950e5d031d5346ae35.svg";
export { ForwardRef as ReactComponent };